import React from 'react';

export const Subtitle2 = ({ name, parcela }) => {
  return (
    <>
      <div
        style={{
          width: '30%',
        }}
        className="mr-1">
        <p
          style={{
            lineHeight: '18px',
          }}
          className="mb-0">
          Editando parcela:
        </p>
        <p style={{ fontSize: '16px' }} className="mb-0 font-weight-bold">
          {parcela}
        </p>
      </div>
      <div>
        <p className="mb-0">Productor/a:</p>
        <p style={{ marginBottom: 0, fontSize: '16px', fontWeight: 'bold' }} className="mb-0 font-weight-bold">
          {name}
        </p>
      </div>
    </>
  );
};

export default Subtitle2;
